import {setCookie} from "./cookie.ts";
import { API_URL } from "../config.tsx";

export function changeCurrentTown (townId: number) {
    setCookie('townId', townId);

    fetch(
        `${API_URL}/set_town/${townId}`,
        {
            method: 'POST',
            credentials: 'include',
        },
    );

    return townId;
};

export function changeCurrentBranch (branchId: number) {
    setCookie('branchId', branchId);

    fetch(
        `${API_URL}/set_branch/${branchId}`,
        {
            method: 'POST',
            credentials: 'include',
        },
    );

    return branchId;
};
